import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddCommentComponent } from './comments/add-comment.component';
import { CommentContext, ReferenceType, AddEditCommentModel } from './comments/add-comment.model';
import { WorkOrderDetailsService } from './work-order-details.service';
import { WorkOrderCommentsService } from './work-order-comments.service';

@Component({
  selector: 'app-comment-panel',
  templateUrl: './comment-panel.component.html',
  styleUrls: ['./comment-panel.component.scss'],
  standalone: false,
})
export class CommentPanelComponent implements OnInit {
  @Input() public referenceId?: string;
  @Input() public referenceName?: string;
  @Input() public referenceType: ReferenceType;

  public workOrderId: string;

  constructor(
    private dialog: MatDialog,
    private workOrderService: WorkOrderDetailsService,
    private workOrderCommentsService: WorkOrderCommentsService,
  ) {}

  ngOnInit(): void {
    this.workOrderId = this.workOrderService.get().id;
  }

  showCommentsLink() {
    const comments = this.workOrderCommentsService.get();
    if (!Array.isArray(comments) || comments.length === 0) return false;
    if (this.referenceType === 'WORK_ORDER') {
      return comments.some((c) => c.referenceType === this.referenceType);
    }
    return comments.some((c) => c.referenceId === this.referenceId && c.referenceType === this.referenceType);
  }

  getCommentsLink() {
    if (this.referenceType === 'WORK_ORDER') {
      return `/work-order/${this.workOrderId}/comments/${this.referenceType}`;
    }
    return `/work-order/${this.workOrderId}/comments/${this.referenceType}/${this.referenceId}`;
  }

  showAddComment(): void {
    const context: CommentContext = {
      referenceId: this.referenceId === undefined ? null : this.referenceId,
      referenceName: this.referenceName,
      referenceType: this.referenceType,
    };
    const addData: AddEditCommentModel = { context, comment: null };
    this.dialog.open(AddCommentComponent, {
      width: '90vw',
      maxWidth: '810px',
      position: { top: '10%', left: '10%' },
      panelClass: 'dwo-dialog',
      data: addData,
    });
  }
}
